export const ScalableIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <g clipPath="url(#clip0_2738_2465)">
                <path d="M19.8906 6.24878V0.623779H14.2656" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19.8906 0.623779L7.39062 13.1238" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.89062 4.37378H2.39062C2.0591 4.37378 1.74116 4.50548 1.50674 4.7399C1.27232 4.97432 1.14063 5.29226 1.14062 5.62378V18.1238C1.14063 18.4553 1.27232 18.7732 1.50674 19.0077C1.74116 19.2421 2.0591 19.3738 2.39062 19.3738H14.8906C15.2221 19.3738 15.5401 19.2421 15.7745 19.0077C16.0089 18.7732 16.1406 18.4553 16.1406 18.1238V10.6238" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2738_2465">
                    <rect width="20" height="20" fill="white" transform="translate(0.515625 0.000488281)" />
                </clipPath>
            </defs>
        </svg>
    )
}